var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.message),expression:"message"}]},[_c('p',{staticClass:"text-sm text-red-600"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }